import { colors } from "../../../../../components/colors";
import { DetailsRow } from "../../../../../components/DetailsRow";
import { formatMoneyAmount } from "../../../../../util";
import { CardHeader } from "../../../../../components/CardHeader";
import { Order } from "../../../model/OrderSuccessResponse";
import { OrderProductLines } from "./OrderProductLines";

interface OrderSummaryProps {
  order: Order | undefined;
}

export const OrderSummary = ({ order }: OrderSummaryProps) => {
  return (
    <div className="card">
      <CardHeader title="Order summary" />
      <div className="card-body d-flex flex-column" style={{ gap: "16px" }}>
        <OrderProductLines orderLines={order?.lines!} />
        {order?.total && (
          <DetailsRow
            leftText={"Total"}
            leftTextColor={colors.textPrimary}
            leftTextFont="bodyTextSemibold"
            rightText={formatMoneyAmount(
              order?.total.amount,
              order?.total.currency
            )}
            rightTextFont="bodyTextSemibold"
          />
        )}
      </div>
    </div>
  );
};
